import { HighlightTone, PaletteColor, ToneColors } from '../types/highlights'

export interface PaletteStyle {
  label: string
  chip: string
  text: string
  flag: string
  divider: string
  swatch: string
}

export const palette: Record<PaletteColor, PaletteStyle> = {
  rose: {
    label: 'Rose',
    chip: 'bg-rose-50 border-rose-200 hover:border-rose-300',
    text: 'text-rose-800',
    flag: 'bg-rose-100 text-rose-700',
    divider: 'border-rose-200',
    swatch: 'bg-rose-600',
  },
  orange: {
    label: 'Orange',
    chip: 'bg-orange-50 border-orange-200 hover:border-orange-300',
    text: 'text-orange-800',
    flag: 'bg-orange-100 text-orange-800',
    divider: 'border-orange-200',
    swatch: 'bg-orange-500',
  },
  amber: {
    label: 'Amber',
    chip: 'bg-amber-50 border-amber-200 hover:border-amber-300',
    text: 'text-amber-800',
    flag: 'bg-amber-100 text-amber-800',
    divider: 'border-amber-200',
    swatch: 'bg-amber-500',
  },
  emerald: {
    label: 'Emerald',
    chip: 'bg-emerald-50 border-emerald-200 hover:border-emerald-300',
    text: 'text-emerald-800',
    flag: 'bg-emerald-100 text-emerald-800',
    divider: 'border-emerald-200',
    swatch: 'bg-emerald-600',
  },
  teal: {
    label: 'Teal',
    chip: 'bg-teal-50 border-teal-200 hover:border-teal-300',
    text: 'text-teal-800',
    flag: 'bg-teal-100 text-teal-800',
    divider: 'border-teal-200',
    swatch: 'bg-teal-600',
  },
  sky: {
    label: 'Sky',
    chip: 'bg-sky-50 border-sky-200 hover:border-sky-300',
    text: 'text-sky-800',
    flag: 'bg-sky-100 text-sky-800',
    divider: 'border-sky-200',
    swatch: 'bg-sky-600',
  },
  indigo: {
    label: 'Indigo',
    chip: 'bg-indigo-50 border-indigo-200 hover:border-indigo-300',
    text: 'text-indigo-800',
    flag: 'bg-indigo-100 text-indigo-800',
    divider: 'border-indigo-200',
    swatch: 'bg-indigo-600',
  },
  violet: {
    label: 'Violet',
    chip: 'bg-violet-50 border-violet-200 hover:border-violet-300',
    text: 'text-violet-800',
    flag: 'bg-violet-100 text-violet-800',
    divider: 'border-violet-200',
    swatch: 'bg-violet-600',
  },
  slate: {
    label: 'Slate',
    chip: 'bg-slate-100 border-slate-300 hover:border-slate-400',
    text: 'text-slate-800',
    flag: 'bg-slate-200 text-slate-700',
    divider: 'border-slate-300',
    swatch: 'bg-slate-500',
  },
}

export const paletteOrder: PaletteColor[] = [
  'rose',
  'orange',
  'amber',
  'emerald',
  'teal',
  'sky',
  'indigo',
  'violet',
  'slate',
]

export const neutralChip: PaletteStyle = {
  label: 'None',
  chip: 'bg-slate-50 border-[#d9e2ef] hover:border-[#b9cbe8]',
  text: 'text-slate-900',
  flag: 'bg-slate-100 text-slate-600',
  divider: 'border-slate-200',
  swatch: 'bg-white',
}

export const toneLabels: Record<HighlightTone, string> = {
  critical: 'Critical',
  warning: 'Attention',
  info: 'Watch',
  positive: 'On track',
}

export const toneOrder: HighlightTone[] = ['critical', 'warning', 'info', 'positive']

export const defaultToneColors: ToneColors = {
  critical: 'rose',
  warning: 'amber',
  info: 'sky',
  positive: 'emerald',
}

export function styleForTone(tone: HighlightTone, toneColors: ToneColors): PaletteStyle {
  return palette[toneColors[tone]]
}
